import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DashboardService } from '../../dashboard.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from 'app/auth/auth.service';

@Component({
    selector: 'app-dashboard-sidebar',
    standalone: true,
    imports: [
        MatProgressBarModule,
        TranslateModule,
        CommonModule,
        RouterModule,
        MatIconModule,
    ],
    templateUrl: './dashboard-sidebar.component.html',
    styleUrl: './dashboard-sidebar.component.scss',
})
export class DashboardSidebarComponent {
    @Input() haveNotifications: boolean = false;
    @Input() isOpen: boolean = false;
    @Output() toggleSidebar = new EventEmitter<string>();
    userData: any;
    activeRoute: string = '';
    gtmTags: any = [];

    menuData = [
        {
            name: 'COMMON.OVERVIEW',
            icon: {
                light: 'assets/images/dashboard/icons/overview_white.svg',
                dark: 'assets/images/dashboard/icons/overview_dark.svg',
            },
            route: '/dashboard',
            ga_event_id: 'Overview',
        },
        {
            name: 'COMMON.APPLICATION_DASHBOARD',
            icon: {
                light: 'assets/images/dashboard/icons/application_white.svg',
                dark: 'assets/images/dashboard/icons/application_dark.svg',
            },
            route: '/applications',
            ga_event_id: 'Applications',
        },
        {
            name: 'NOTIFICATIONS.TITLE',
            icon: {
                light: 'assets/images/dashboard/icons/notifications_white.svg',
                dark: 'assets/images/dashboard/icons/notifications_dark.svg',
            },
            route: '/notifications',
        },
        {
            name: 'REDEEM.TITLE',
            icon: {
                light: 'assets/images/dashboard/icons/referrals_white.svg',
                dark: 'assets/images/dashboard/icons/referrals_dark.svg',
            },
            route: '/rewards',
        },
        {
            name: 'COMMON.CGC_PROGRAMME',
            icon: {
                light: 'assets/images/dashboard/icons/cgc_white.svg',
                dark: 'assets/images/dashboard/icons/cgc_dark.svg',
            },
            route: '/cgc-developmental-programme',
            ga_event_id: 'cgc_developmental_programme',
        },
        {
            name: 'JC3.FEEDBACK_FORM',
            icon: {
                light: 'assets/images/dashboard/icons/feedback_form_white.svg',
                dark: 'assets/images/dashboard/icons/feedback_form_dark.svg',
            },
            route: '/feedback-form',
            ga_event_id: 'feedback_form',
        },
    ];
    subRoutes = [
        {
            name: 'GO_TO_IMSME',
            route: '/home',
            img: '/assets/images/dashboard/icons/home.svg',
            ga_event_id: 'go_to_imsme',
        },
        {
            name: 'COMMON.HELP_CONTACT',
            route: '/contact-us',
            img: '/assets/images/dashboard/icons/contact.svg',
            ga_event_id: 'contact_us',
        },
        {
            name: 'COMMON.FAQ',
            route: '/faq',
            img: '/assets/images/dashboard/icons/faqs.svg',
            ga_event_id: 'faqs',
        },
    ];
    previewImageUrl: string | ArrayBuffer | null = null;
    profileCompletionPercent = 0;

    constructor(
        private _dashService: DashboardService,
        private router: Router,
        public authService: AuthService
    ) {
        // Set the initial active route based on current URL
        this.activeRoute = this.router.url;
        this.userData = this._dashService.getUser();
        this._dashService.getProfileImageUrl$().subscribe((url) => {
            this.previewImageUrl = url ?? '/assets/images/user-placeholder.png';

            if (this.userData && this.previewImageUrl) {
                const profileStatus = this._dashService.getProfileCompletion(
                    this.userData,
                    this.previewImageUrl
                );

                this.profileCompletionPercent = profileStatus.completion;
            }
        });
    }

    onClickCompleteProfile() {
        this.router.navigate(['/profile']);
    }

    setActiveRoute(route: string): void {
        this.activeRoute = route;
    }
}
